import React from 'react'
import { createPortal } from 'react-dom'

const SpeedVector = ({ trackLayerSvg, children }) => {
  return createPortal(<>{children}</>, trackLayerSvg.current.children[1])
}

export default SpeedVector
